module.exports = __webpack_public_path__ + "media/ringtone.09e131bb.mp3";